import styled from 'styled-components';
import colors from '../../../../utils/colors';

export const ModalBackground = styled.div`
	flex: 1;
	inset: 11% 15%;
	margin: auto;
	display: flex;
	position: fixed;
	overflow: hidden;
	max-width: 1536px;
	border-radius: 24px;
	flex-direction: column;
	z-index: $z-index-modal;
	animation: fade-in 0.4s ease-out;
	background-color: ${colors.blGrayscale900};
`;

export const LibraryHeader = styled.div`
	color: #ffffff;
	position: relative;
	display: flex;
	justify-content: space-between;
	padding: 24px 40px 0 40px;
`;

export const LibraryFooter = styled.div`
	color: ${colors.blGrayscale300};
	position: relative;
	display: flex;
	justify-content: space-between;
	padding: 24px 40px;
`;

export const CardContainerContainer = styled.div`
	scrollbar-gutter: stable;
	flex: 1;
	padding-top: 16px;
	margin: 0 12px 0 calc(40px - 1em);
	overflow-y: auto;
	max-height: 70vh;
`;

export const CardContainer = styled.div`
	@include custom-scrollbar(24px, 1);
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
`;

export const FileBadge = styled.div`
	padding: 2px 8px;
	text-transform: uppercase;
	position: absolute;
	right: 8px;
	top: 8px;
	border-radius: 100px;
`;

export const CheckBox = styled.div`
	position: absolute;
	left: 8px;
	top: 8px;
	opacity: 0;
	transition: 0.2s all ease-out;

	&.selected {
		opacity: 1;
	}
`;

export const Card = styled.div`
	aspect-ratio: 16/9;
	margin: 0 1em;
	position: relative;
	cursor: pointer;
	line-height: 0;
	flex-basis: calc(33.33% - 2em);
	max-width: calc(33.33% - 2em);
	padding: 0;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	
	.scaled-container {
		// shadow #4 on css shadows site
		box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
		transition: 0.2s all ease-out;
		cursor: pointer;
		border-radius: 8px;
	}

	&:hover {
		.checkbox {
			opacity: 1;
		}
			
		.scaled-container {
			// shadow #5 on css shadows site
			box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
		}
	}

	&:active {
		.checkbox {
			opacity: 1;
		}
			
		.scaled-container {
			// shadow #6 on css shadows site
			box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 8px 0px;
			transform: scale(0.99);
		}

		img {
			filter: brightness(105%);
		}
	}
`;

export const ImageContainer = styled.div`
	position: relative;
	width: 100%;
	aspect-ratio: 16/9;
	background: ${colors.blGrayscale800};
	background-color: ${colors.blGrayscale800};
	border-radius: 8px;
	img {
		border-radius: 8px;
		width: 100%;
		min-width: 100%;
		aspect-ratio: 16/9;
		object-fit: cover;
		background: transparent;
	}
	&.empty-media-lib-image {
		background: none;
		width: fit-content;

		img {
			aspect-ratio: unset;
			object-fit: contain;
		}
	}
`;

const shadow = `
	position: absolute;
	height: 16px;
	left: 12px;
	right: 12px;
	z-index: 4;
`;

export const Shadow = styled.div`
	${shadow}
	top: 48px;
	background: linear-gradient(360deg, rgba(38, 36, 43, 0) 0%, ${colors.blGrayscale900} 100%);
`;

export const ShadowBottom = styled.div`
	${shadow}
	bottom: 96px;
	background: linear-gradient(180deg, rgba(38, 36, 43, 0) 0%, ${colors.blGrayscale900} 100%);
`;

export const MediaTitle = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;
	margin: 1em 0;
	cursor: auto;
	transition: 0.1s all ease-out;
	display: block;	
`;

export const GradientBackdrop = styled.div`
	position: absolute;
	width: 474px;
	height: 378px;
	left: calc(50% - calc(474px / 2));
	top: calc(50% - calc(378px / 2));
	background: #A6FF79;
	opacity: 0.2;
	filter: blur(200px);
`;

export const EmptyState = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	color: ${colors.blGrayscale300};
`;
